const capitalizeFirstLetter = (string: string) => {
  return string ? string[0].toUpperCase() + string.slice(1).toLowerCase() : ''
}

export default capitalizeFirstLetter
